import type { Summary } from "@idea-studio/shared";

interface Props {
  summary?: Summary;
  onBack: () => void;
}

export function RunScreen({ summary, onBack }: Props) {
  const focus = summary?.current_focus;

  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between border-b border-neutral-900 pb-4">
        <button
          type="button"
          onClick={onBack}
          className="text-[14px] text-neutral-400 transition-colors active:text-neutral-200"
        >
          Terug
        </button>
        <span className="text-[10px] font-medium uppercase tracking-[0.22em] text-neutral-500">
          Run systeem
        </span>
        <span className="w-12" aria-hidden="true" />
      </div>

      <section className="space-y-2.5">
        <h2 className="text-[10px] font-medium uppercase tracking-[0.22em] text-neutral-500">
          Volgende stap
        </h2>
        <p className="text-[15px] leading-relaxed text-neutral-100">
          {focus?.next_action ?? "Geen actie vereist op dit moment."}
        </p>
      </section>

      {focus?.blocker && (
        <section className="space-y-2.5">
          <h2 className="text-[10px] font-medium uppercase tracking-[0.22em] text-neutral-500">
            Blokkade
          </h2>
          <p className="text-[15px] leading-relaxed text-amber-200/90">{focus.blocker}</p>
        </section>
      )}

      <section className="space-y-3">
        <h2 className="text-[10px] font-medium uppercase tracking-[0.22em] text-neutral-500">
          Vanuit de app starten
        </h2>
        <div className="rounded-2xl border border-neutral-800/80 bg-neutral-900/40 p-5">
          <p className="text-[13.5px] leading-relaxed text-neutral-400">
            Komt in een latere fase: één tap triggert de runner via GitHub Actions,
            uitgevoerd door Claude. Voorlopig draai je de volgende stap lokaal:
          </p>
          <pre className="mt-4 overflow-x-auto rounded-lg border border-neutral-800/60 bg-neutral-950 px-4 py-3 font-mono text-[11.5px] leading-relaxed text-neutral-300">
{`python scripts/triage_runner.py
python scripts/selection_runner.py`}
          </pre>
        </div>
      </section>
    </div>
  );
}
